export function useBlockedLocalStoreRemove() {
  const whiteListKeys = [
    'last_rm_visit_stag',
    'session_time',
    'appservicepartner',
    'ref_code',
    'playerData',
    '7BIT_COUPON_CODE',
    'userData',
    'isFraudEmail',
    'playerBalance',
    'userCurrencyManual',
    'isOptedOut', // One Signal event
    'isPushNotificationsEnabled', // One Signal event
  ];

  const originalRemove = Storage.prototype.removeItem;

  Object.defineProperty(Storage.prototype, 'removeItem', {
    value: function (key: string) {
      if (whiteListKeys.includes(key)) {
        return originalRemove.call(this, key);
      }
      throw new Error('Blocked');
    },
    writable: false,
    configurable: false,
  });

  Object.defineProperty(Storage.prototype, 'clear', {
    value: function () {
      throw new Error('Blocked');
    },
    writable: false,
    configurable: false,
  });
}
